import { Accordion, AccordionDetails } from '@material-ui/core';
import { useState } from 'react';

import { AccordionStyledSummary } from '@/components/modules/OrderActivity/components/AccordionStyledSummary';
import { ActionExpandedDetails } from '@/components/modules/OrderActivity/components/ActionExpandedDetails';
import { ActionSummary } from '@/components/modules/OrderActivity/components/ActionSummary';
import { OrderAction } from '@/components/modules/OrderActivity/types/OrderAction';
import { OrderActionType } from '@/components/modules/OrderActivity/types/OrderActionType';
import { CaptureStatusTag } from '@/components/shared/components/StatusTag/Tags/CaptureStatusTag';
import { OrderStatusTag } from '@/components/shared/components/StatusTag/Tags/OrderStatusTag';
import { PayoutStatusTag } from '@/components/shared/components/StatusTag/Tags/PayoutStatusTag';
import { RefundStatusTag } from '@/components/shared/components/StatusTag/Tags/RefundStatusTag';

interface ActionDetailAccordionProps {
  action: OrderAction;
}

export const ActionDetailAccordion = ({ action }: ActionDetailAccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const getTag = (type, status) => {
    switch (type) {
      case OrderActionType.capture:
        return <CaptureStatusTag status={status} />;
      case OrderActionType.refund:
        return <RefundStatusTag status={status} />;
      case OrderActionType.payout:
        return <PayoutStatusTag status={status} />;
      case OrderActionType.order:
        return <OrderStatusTag status={status} />;
    }
  };

  return (
    <>
      <Accordion
        variant={'elevation'}
        elevation={0}
        expanded={expanded}
        onChange={toggleExpanded}
        style={{ background: 'inherit' }}
      >
        <AccordionStyledSummary expanded={expanded}>
          <ActionSummary
            type={action.type}
            number={action.number}
            tag={getTag(action.type, action.status)}
            createdAt={action.createdAt}
            amount={action.amount}
          />
        </AccordionStyledSummary>
        <AccordionDetails style={{ padding: '14px 8px 0px 14px' }}>
          <ActionExpandedDetails
            id={action.id}
            description={action.description}
            orderLineInActions={action.orderLines}
            amount={action.amount}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
};
